'use strict';

import GenericTableData from './GenericTableData';

// Shipping Module Event Bus. Handles all interactions with Shipping.
let ShippingData = GenericTableData.getTableDataBus('SHIP', 'shipping');

export default ShippingData;
